import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const GenReviewsDiffs = () => {
    const [generatedReviews, setGeneratedReviews] = useState([]);
    const [discrepancies, setDiscrepancies] = useState([]);
    const [similarGenReviews, setSimilarGenReviews] = useState(0);

    useEffect(() => {
        fetch(process.env.REACT_APP_BACKEND_URL + 'get_all_ds_genRev_discrep', {
            method: "POST",
            headers: {
                "Content-Type": "text/plain",
            },
            body: JSON.stringify({
                token: localStorage.getItem("token"),
                username: localStorage.getItem("user")
            }),
        })
            .then(response => response.json())
            .then(data => {

                const lcentellasGenReviews = data.filter(c => c.name === "lcentellas" && c.coherent !== null);
                const lcentellasBySha = Object.fromEntries(lcentellasGenReviews.map(c => [c.sha + c.model + c.prompt, c]));

                const others = data.filter(c =>
                    c.name !== "lcentellas" &&
                    lcentellasBySha[c.sha + c.model + c.prompt] &&
                    c.coherent !== null &&
                    (lcentellasBySha[c.sha + c.model + c.prompt].coherent !== c.coherent || 
                        lcentellasBySha[c.sha + c.model + c.prompt].vulnerability !== c.vulnerability || 
                        lcentellasBySha[c.sha + c.model + c.prompt].plausible !== c.plausible)
                );

                setGeneratedReviews(others);
                setDiscrepancies(others);

                const totalRevisedByTwo = data.filter(c =>
                    c.name !== "lcentellas" &&
                    lcentellasBySha[c.sha + c.model + c.prompt] &&
                    c.coherent !== null
                );

                setSimilarGenReviews(totalRevisedByTwo.length);

            })
            .catch(error => {
                console.error("Error:", error);
            });
    }, []);

    function filter() {
        let filtered = generatedReviews;

        const selectedState = document.getElementById("State").value;
        if (selectedState === "Reviewed") {
            filtered = filtered.filter(commit => commit.discrepancy !== null);
        } else if (selectedState === "Not Reviewed") {
            filtered = filtered.filter(commit => commit.discrepancy === null);
        }

        setDiscrepancies(filtered);
    }

    return (
        <>
            <div className="m-10">
                <div className="border-b border-gray-900/10 pb-12 justify-center">
                    <h1 className="text-base font-semibold leading-7 text-gray-900"> Generated Reviews Discrepancies</h1>
                </div>
            </div>

            <div className="m-10 border-b border-gray-900/10">
                <div className="justify-center mb-4">
                    <h2 className="text-base font-medium leading-7 text-gray-900">Filters</h2>
                </div>

                <div className="grid grid-cols-2 gap-4">
                    <div className="col-span-2">
                        <label className="block text-sm font-medium text-gray-700">State:</label>
                        <select id="State" onChange={filter} className="w-full border p-2 rounded">
                            <option value="">All</option>
                            <option value="Reviewed">Reviewed</option>
                            <option value="Not Reviewed">Not Reviewed</option>
                        </select>
                    </div>
                </div>
            </div>

            <div className="m-10">
                {discrepancies.length > 0 && (
                    (() => {
                        const secureCount = discrepancies.filter(c => c.discrepancy !== null).length;
                        const total = discrepancies.length;
                        const percentage = (secureCount / total) * 100;

                        // Calculate green color: hue=120 (green) and adjust lightness
                        const lightness = 80 - (percentage * 0.5); // from 80% (light) to 30% (dark)
                        const barColor = `hsl(120, 60%, ${lightness}%)`;

                        return (
                            <div className="flex items-center space-x-4">
                                <div className="w-full bg-gray-200 rounded-full h-6 relative">
                                    <div
                                        className="h-6 rounded-full transition-all duration-500"
                                        style={{
                                            width: `${percentage}%`,
                                            backgroundColor: barColor,
                                        }}
                                    ></div>
                                </div>
                                <div className="text-sm font-semibold text-gray-700 whitespace-nowrap">
                                    {secureCount} / {total} of {similarGenReviews}
                                </div>
                            </div>
                        );
                    })()
                )}
            </div>

            <div className="m-10">
                {discrepancies.length === 0 ? (
                    <p>No discrepancies</p>
                ) : (
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4">
                        {discrepancies.map(review => (
                            <div key={review.sha + review.model + review.prompt}
                                className={`col-span-1 shadow-md hover:shadow-lg m-5 p-4 rounded cursor-pointer ${
                                    review.discrepancy === null ? '' : 'bg-gray-400'
                                }`}>
                                <Link to={`/genReviewsDiff/${review.sha}/${review.model.replace(/\//g, '_')}/${review.prompt}`}>
                                    <p><b>SHA:</b> {review.sha} <b>Model:</b> {review.model} <b>Prompt:</b> {review.prompt}</p>
                                </Link>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </>
    );
};

export default GenReviewsDiffs;
